/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />


namespace TabAurous.Retail {
    import fld = POSSalesItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class POSSalesWithoutTaxItemsEditor extends _Ext.ItemGridEditor<POSSalesItemsRow> {
        protected getColumnsKey() { return "Retail.POSSalesItems"; }
        protected getDialogType() { return POSSalesItemsDialog; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        protected

        protected form: POSSalesItemsForm;
        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }

        // #region Variables
        public salespersonId = 0;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;

        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number;
        public TotalItems: number;
        public ProductTypeId: number; 
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSSalesDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }

        setMasterValues() {
            this.RateListId = (this.parentDialog as POSSalesDialog).RateListId;
            this.LaborListId = (this.parentDialog as POSSalesDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as POSSalesDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as POSSalesDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as POSSalesDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as POSSalesDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as POSSalesDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as POSSalesDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as POSSalesDialog).form.POSCustomerId.value);
            this.salespersonId = parseInt((this.parentDialog as POSSalesDialog).form.EmployeeId.value);
        } 
        protected createToolbarExtensions(): void {
            super.createToolbarExtensions();

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSSalesDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })

        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU

            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {
                    Quantity += x.Pieces;
                };

                if (Quantity > 0) {
                    var Item = StockID.pop();
                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.DiscountPer).format = num;

            Q.first(columns, x => x.field === fld.Pieces).format = ctx => {
                if (ctx.item.ItemTypeId != 104)
                    return this.isReadOnly == false ? ColumnFormatter.integerInputFormatter(ctx, this) : ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
                else
                    return this.isReadOnly == false ? ctx.item.CategoryId != "7" ? ColumnFormatter.ReadOnlyIntegerInput(ctx, this) : ColumnFormatter.integerInputFormatter(ctx, this) : ColumnFormatter.ReadOnlyIntegerInput(ctx, this);
            }

            Q.first(columns, x => x.field === fld.Weight).format = ctx => {
                if (ctx.item.ItemTypeId == 101 && ctx.item.HasBom)
                    return ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
                else
                    return this.isReadOnly == false ? ColumnFormatter.WeightFormatter(ctx, this) : ColumnFormatter.ReadOnlyWeightFormatter(ctx, this);
            }

            Q.first(columns, x => x.field === fld.UnitRate).format = ctx => {
                if (ctx.item.ItemTypeId == 101 && ctx.item.HasBom)
                    return ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
                else
                    return this.isReadOnly == false ? ColumnFormatter.AmountFormatter(ctx, this) : ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
            }
            Q.first(columns, x => x.field === fld.Discount).format = ctx => {
                return this.isReadOnly == false ? ColumnFormatter.AmountFormatter(ctx, this) : ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
            }
            Q.first(columns, x => x.field === fld.DiscountPer).format = ctx => {
                return this.isReadOnly == false ? ColumnFormatter.numericInputFormatter(ctx, this) : ColumnFormatter.ReadonlynumericInputFormatter(ctx, this);
            }

            var Employee = Q.first(columns, x => x.field === fld.EmployeeId);
            Employee.referencedFields = [fld.EmployeeId];
            Employee.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.EmployeeId, Master.EmployeeMasterRow.getLookup(), this);


            let EditGrossAmount = q.ToBool(GetConfigValue(1030)); 
            if (EditGrossAmount && !this.isReadOnly) {
                var GrossAmount = Q.first(columns, x => x.field === fld.GrossAmount);
                GrossAmount.referencedFields = [fld.GrossAmount];
                GrossAmount.format = ctx => {
                    return this.isReadOnly == false ? ColumnFormatter.AmountFormatter(ctx, this) : ColumnFormatter.ReadOnlyAmountFormatter(ctx, this);
                }
            }


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;

            return this.TotalItems;
        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;


            let CurrentStock: Stock.StockItemRow;

            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                AttributeId: item.AttributeId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                LotNo: item.LotNo,
                TransId: item.TransId,
                TransItemId: item.TransItemId
            },
                response =>
                    CurrentStock = response.Entity,
                { async: false }
            );


            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (value > CurrentStock.Pieces) {
                    q.Alert('Invalid Entry', 'Entered pieces are more than available stock', 2500, false);
                    item[field] = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }

            }

            //}

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId != 101) {
                if (value > CurrentStock.Pieces) {
                    q.Alert('Invalid Entry', 'Entered pieces are more than available stock', 1000, false);
                    item[field] = CurrentStock.Pieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;
                }
                item[field] = value;
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (value > CurrentStock.Weight) {
                    q.Alert('Invalid Entry', 'Entered weight is more than available stock', 1000, false);
                    item[field] = CurrentStock.Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId != 3) {
                    var Net = ((item.UnitRate + item.UnitLabour) / item.Weight) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }

                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                var laboramount = item.UnitLabour;
                if (value > laboramount) {

                    q.Alert('', 'Discount Policies will be affected, cannot apply Discount', 2999, true);
                    item[field] = 0;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                Common.CommonService.GetItemDiscount({
                    Discount: value,
                    LaborDetails: item.LaborDetails
                }, response => {
                    var x = response;
                    if (response.Entities == null) {
                        q.Warning('', 'Discount Policies will be affected, cannot apply Discount', true);
                        item[field] = 0;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        item.LaborDetails = labors;
                        item[field] = value;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                        item.GrossAmount = item.GrossAmount - value;
                        item.DiscountPer = (value / item.NetAmount) * 100;
                        //this.form.LaborDetails.setData(labors);
                    }
                }, { async: false })
                //Q.reloadLookup(Administration.ItemDiscountDetailsRow.lookupKey);
                //var DiscountPer = (value / item.NetAmount) * 100;
                //try {
                //    var AllowedDiscount = Q.tryFirst(Administration.ItemDiscountDetailsRow.getLookup().items, x => x.Id == 2 && x.ProductTypeId == item.ProductTypeId).MaxDiscount;

                //}
                //catch (undefined) {
                //    AllowedDiscount = 100000;
                //}

                //if (AllowedDiscount != undefined && DiscountPer <= AllowedDiscount) {
                //    item.GrossAmount = item.NetAmount - value;
                //    item.DiscountPer = (value / item.NetAmount) * 100;
                //    item[field] = value;
                //    var Fancy = item.LaborDetails.filter(x => x.ProcessName == "Fancy Charges");
                //    var Balance = 0;
                //    if (Fancy.length > 0) {
                //        if (value > Fancy[0].LabourAmount) {
                //            Balance = value - Fancy[0].LabourAmount;
                //            Fancy[0].LabourAmount = 0;
                //            Fancy[0].LabourRate = 0;
                //        }
                //        else {
                //            Fancy[0].LabourAmount = Fancy[0].LabourAmount - value;
                //            Fancy[0].LabourRate = Fancy[0].LabourAmount / Fancy[0].Weight;
                //        }
                //        if (Balance > 0) {

                //            var Making = item.LaborDetails.filter(x => x.ProcessName == "Making Charges");
                //            Making[0].LabourAmount = Making[0].LabourAmount - Balance;
                //            Making[0].LabourRate = Making[0].LabourAmount / Making[0].Weight;
                //        }
                //    }
                //    else {

                //        var Making = item.LaborDetails.filter(x => x.ProcessName == "Making Charges");
                //        if (value < Making[0].LabourAmount) {
                //            Making[0].LabourAmount = Making[0].LabourAmount - value;
                //            Making[0].LabourRate = Making[0].LabourAmount / Making[0].Weight;
                //        }
                //        else
                //            q.Warning("Not Allowed", "Discount value is more than Making Charges", false);

                //    }

                //    var lamount = 0;
                //    item.LaborDetails.forEach(function (x) {
                //        lamount += x.LabourAmount;
                //    });
                //    item.UnitLabour = lamount;

                //}
                //else {
                //    Q.warning(q.text('Message.Discount.NotAllowed', 'You are not Authorized to give that much discount'))
                //}

            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = ((item.NetAmount + item.UnitLabour) * value) / 100;
                var laboramount = item.UnitLabour;
                if (Discount > laboramount) {

                    q.Alert('', 'Discount cannot be greater than Labor Amount', 2999, true);
                    item[field] = 0;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                Common.CommonService.GetItemDiscount({
                    Discount: Discount,
                    LaborDetails: item.LaborDetails
                }, response => {
                    if (response.Entities == null) {
                        q.Alert('', 'Discount Policies will be affected, cannot apply Discount', 2999, true);
                        item[field] = 0;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                        item.GrossAmount = item.GrossAmount - value;
                        item.DiscountPer = (value / item.NetAmount) * 100;
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        item.LaborDetails = labors;
                        item[field] = value;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                        var Discount = (item.NetAmount * value) / 100
                        item.GrossAmount = item.NetAmount + item.UnitLabour - Discount;
                        item.Discount = Discount;
                        //this.form.LaborDetails.setData(labors);
                    }
                }, { async: false })


            }

            // *** Calculate Discount   ***
            if (field === fld.GrossAmount && value >= 0) {
                var Discount = (item.NetAmount + item.UnitLabour) - value;
                var laboramount = item.UnitLabour;
                if (Discount > laboramount) {

                    q.Alert('', 'Discount cannot be greater than Labor Amount', 2999, true);
                    item[field] = 0;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                Common.CommonService.GetItemDiscount({
                    Discount: Discount,
                    LaborDetails: item.LaborDetails
                }, response => {
                    if (response.Entities == null) {

                        q.Alert('', 'Discount Policies will be affected, cannot apply Discount', 2999, true);
                        item[field] = 0;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        item.LaborDetails = labors;
                        item[field] = value;
                        item.Discount = Discount;
                        item.DiscountPer = (Discount / item.NetAmount) * 100;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                        //this.form.LaborDetails.setData(labors);
                    }
                }, { async: false })



            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as POSSalesDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);



            let returnvalue: string = "";
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        //#region Buttons Add-Remove

        protected getButtons() {
            let buttons = super.getButtons();
             
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {


                    var grid = Common.StockSelectGrid;
                    this.setMasterValues();
                    var salesperson = parseInt((this.parentDialog as POSSalesDialog).form.EmployeeId.value);
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    } else if (isNaN(salesperson)) {
                        Q.notifyWarning("Please select Sales Person to proceed");
                        return;
                    }

                    else {
                        var filter: _Ext.SelectGridFilters = {
                            FilterItems:1
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters:filter
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        let self = this;
                        var ItemDetails = ItemGridHelper.SetRetailItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        ItemDetails.forEach(function (Item: POSSalesItemsRow) {
                            Item.EmployeeId = Q.parseInteger((self.parentDialog as POSSalesDialog).form.EmployeeId.value);
                        });

                        this.setData(ItemDetails, salesperson);
                    }
                   

                    pickerDialog.dialogOpen();
                }
            }); 
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }

        //#endregion

        // #region Set Data

        setData(ItemDetails: any[], employeeid: number) {
            if (this.view.getItems().length > 0) {
                this.TotalItems = ItemDetails.length + this.view.getItems().length;
            }
            else {
                this.TotalItems = ItemDetails.length;
            }
            for (let Itemdetail of ItemDetails) {
                Itemdetail.IsRepairProcess = false;
                Itemdetail.EmployeeId = employeeid;
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion


        public CalculateDiscount(discount: number, totalLabor: number) {

            let items = this.view.getItems();
            let TaxGroupId = Q.Authorization.userDefinition.TaxGroupId;

            for (let item of items) {

                let id = this.id(item);
                let itemtaxrate: number;
                let taxes: OMS.HsnTaxMasterRow;
                let trate= [];

                OMS.HsnTaxMasterService.Retrieve({ EntityId: item.TaxCode }, response => taxes = response.Entity, { async: false })

                if (taxes != null) {
                    let taxDetails = taxes.Details.filter(x => x.GroupId === TaxGroupId);
                    if (taxDetails.length == 1) {
                        itemtaxrate = taxDetails[0].TaxRate;
                    }
                    if (taxDetails.length > 1) {

                        for (let tax of taxDetails) {
                            trate.push(tax.TaxRate);                           
                        }
                        itemtaxrate = Math.max.apply(Math, trate);
                    }
                }
                
                let taxamt = item.GrossAmount * (itemtaxrate / 100);
                let ratio = (item.GrossAmount + taxamt) / totalLabor;
                let dis = discount * ratio;
                let applieddis =dis -(dis / (100 + itemtaxrate) * itemtaxrate);


                Common.CommonService.GetItemDiscount({
                    Discount: applieddis,
                    LaborDetails: item.LaborDetails
                }, response => {
                    if (response.Entities == null) {
                        q.Alert('', 'Discount Policies will be affected, cannot apply Discount', 2999, true);
                        (this.parentDialog as POSSalesDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        item.LaborDetails = labors;
                        item.Discount = applieddis;
                        item.DiscountPer = (applieddis / item.GrossAmount) * 100;
                        item.GrossAmount = item.GrossAmount - applieddis;

                        let SplitLabor = q.ToBool(GetConfigValue(1033)); 
                        if (SplitLabor) {
                            item.UnitLabour = 0;
                            item.FancyCharges = 0;
                            item.OtherCharges = 0;
                            for (var l of item.LaborDetails) {
                                let discount = l.Discount == undefined ? 0 : l.Discount;
                                switch (l.CalculateTo) {
                                    case 1:
                                        item.UnitLabour += l.LabourAmount - discount;
                                        break;
                                    case 2:
                                        item.FancyCharges += l.LabourAmount - discount;
                                        break;
                                    case 3:
                                        item.OtherCharges += l.LabourAmount - discount;
                                        break;
                                }

                            }
                        }


                        this.view.updateItem(id, item);
                        this.view.refresh();
                        (this.parentDialog as POSSalesDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                        
                    }
                }, { async: false })

            }

        }

    }
}